// Spanish translations for BIMCORP MX.
// Edit strings here. Structure must mirror en.js.

const es = {
  nav: {
    howItWorks: "Cómo Funciona",
    services: "Servicios",
    fit: "Ruta",
    insights: "Insights",
    faq: "Preguntas Frecuentes",
    startCta: "Iniciar incorporación"
  },
  hero: {
    title: "BIMCORP MX",
    subtitle: "Constituye tu empresa en México, con la estructura correcta.",
    description: "Servicio de constitución de sociedades personalizado para fundadores, inversionistas y empresarios que llegan a México.",
    description2: "Cuéntanos tu proyecto. Diseñamos tu estructura legal y gestionamos todo el proceso en línea.",
    animatedTitle: "Constituye una empresa",
    animatedSubtitle: "en México",
    lawyerLed: "Dirigido por abogados",
    notaryBacked: "Respaldado por notario",
    fullyOnline: "Totalmente en línea",
    tailoredFounders: "A la medida"
  },
  sections: {
    whatWeHandle: "De qué nos encargamos",
    whatWeHandleDesc: "Desde la constitución de la empresa hasta la puesta en operación y el cumplimiento continuo.",
    builtFor: "Diseñado para",
    howItWorks: "Un proceso claro: de la idea a la constitución de tu sociedad",
    chooseRoute: "Elige la ruta adecuada",
    installmentsAvailable: "(Pagos en parcialidades disponibles)",
    buildingComplex: "¿Tu proyecto en México es más complejo?",
    buildingComplexDesc: "Para transacciones complejas o estructuras de inversión específicas que requieren un enfoque jurídico a la medida.",
    commonQuestions: "Preguntas frecuentes",
    viewAllQuestions: "Ver todas las preguntas →",
    startWithStructure: "Empieza con la estructura correcta",
    startWithStructureDesc: "Inicia tu solicitud de incorporación y te recomendaremos la mejor ruta antes de tu llamada.",
    notSureRoute: "¿No sabes cuál ruta le conviene a tu negocio?",
    notSureRouteDesc: "Compara las opciones disponibles y elige el nivel de acompañamiento que tu empresa necesita en México.",
    findYourFit: "Encuentra tu ruta"
  },
  services: {
    companyIncorporation: "Constitución de la sociedad",
    companyIncorporationDesc: "Gestionamos todo el proceso de constitución, desde la coordinación notarial hasta la inscripción final ante las autoridades.",
    rfcSetup: "RFC y e.firma",
    rfcSetupDesc: "Tramitamos el RFC de tu sociedad y la obtención de su e.firma ante el SAT para que pueda operar formalmente.",
    bankAccount: "Apertura de cuenta bancaria",
    bankAccountDesc: "Coordinamos el proceso de apertura y activación de tu cuenta bancaria corporativa.",
    governance: "Gobierno corporativo y cumplimiento",
    governanceDesc: "Llevamos libros corporativos, emisión de acciones, asambleas anuales, protección de marca y registros relacionados con inversión extranjera."
  },
  specialServices: {
    restrictedZone: "Inmuebles en zona restringida",
    restrictedZoneDesc: "Estructuras de propiedad para proyectos inmobiliarios en zonas costeras o fronterizas.",
    landRealEstate: "Terrenos e inmuebles",
    landRealEstateDesc: "Estructuración legal para proyectos de adquisición, desarrollo o propiedad inmobiliaria.",
    tailoredOwnership: "Estructuras de propiedad complejas",
    tailoredOwnershipDesc: "Esquemas a la medida para proyectos con inversión extranjera, múltiples socios o necesidades especiales de control."
  },
  audience: {
    founders: "Fundadores",
    foundersDesc: "Iniciando un negocio en México",
    foreignInvestors: "Inversionistas extranjeros",
    foreignInvestorsDesc: "Entrando al mercado mexicano",
    operators: "Operadores",
    operatorsDesc: "Que necesitan un vehículo legal local",
    projectBuilders: "Desarrolladores de proyectos",
    projectBuildersDesc: "Que requieren estructuras a la medida"
  },
  pricing: {
    oneTimeFee: "pago único",
    upfrontSetup: "cuota inicial",
    monthlyPlan: "compromiso mínimo de 12 meses",
    mostPopular: "Más popular",
    month: "mes",
    perMonthSuffix: "/mes",
    vat: "+IVA"
  },
  pages: {
    servicesHero: "Servicios",
    servicesSubtitle: "Constitución, puesta en operación y cumplimiento corporativo para empresas que operarán en México.",
    howItWorksHero: "Cómo funciona",
    howItWorksSubtitle: "Una ruta personalizada y totalmente en línea para constituir tu empresa en México con la estructura correcta desde el primer día.",
    faqHero: "Preguntas frecuentes",
    faqSubtitle: "Todo lo que necesitas saber para constituir tu empresa en México con BIMCORP MX.",
    wizardHero: "Iniciar incorporación",
    wizardSubtitle: "Cuéntanos qué quieres establecer en México. Te recomendaremos la mejor ruta antes de tu llamada."
  },
  servicesPage: {
    whatHappensNext: "Qué sigue",
    step1: "Inicia tu solicitud de incorporación",
    step1Desc: "Comparte los datos clave de tu proyecto en México y selecciona un paquete si ya sabes cuál te queda",
    step2: "Agenda una llamada de validación de 20 minutos",
    step2Desc: "Revisamos tu solicitud y confirmamos la ruta, el alcance y el servicio adecuado antes de cualquier pago",
    step3: "Pago y onboarding",
    step3Desc: "Una vez alineados, enviamos el enlace de pago y comenzamos tu onboarding",
    step4: "Nos encargamos del proceso",
    step4Desc: "Gestionamos la constitución y, si aplica, el RFC, la cuenta bancaria y el gobierno corporativo",
    step5: "Entrega",
    step5Desc: "Recibes los documentos de tu sociedad y los entregables relacionados",
    readyToStart: "¿Listo para empezar?",
    readyToStartDesc: "Inicia tu solicitud de incorporación y obtén tu recomendación personalizada.",
    specialProjectTitle: "Special Project Structuring",
    specialProjectSubtitle: "Transacciones estratégicas",
    specialProjectDesc: "Estructuración a la medida para inversión extranjera, propiedad inmobiliaria y proyectos complejos en México.",
    specialProjectBullet1: "Proyectos en zona restringida",
    specialProjectBullet2: "Estructuras de propiedad para terrenos e inmuebles",
    specialProjectBullet3: "Esquemas de propiedad y control para proyectos complejos",
    specialProjectPriceLabel: "Cotización",
    specialProjectPriceSub: "después de revisión"
  },
  fitPage: {
    heroTitle: "Encuentra la ruta adecuada para tu negocio",
    heroSubtitle: "No todas las empresas que entran a México necesitan el mismo nivel de acompañamiento. Elige la ruta que corresponde a tu etapa, necesidades operativas y obligaciones de cumplimiento.",
    compareRoutes: "Compara las rutas",
    compareRoutesSub: "Cuatro rutas de orientación. Elige la que corresponde a la etapa y obligaciones de tu empresa.",
    columnPlan: "Plan",
    columnBestFor: "Ideal para",
    columnKeyValue: "Valor principal",
    row1BestFor: "Inversionistas y sociedades holding",
    row1Value: "Una sociedad mexicana correctamente constituida, con sus registros iniciales ante las autoridades.",
    row2BestFor: "Empresas listas para operar",
    row2Value: "Preparación operativa completa: RFC, e.firma y cuenta bancaria corporativa.",
    row3BestFor: "Marcas y empresas establecidas",
    row3Value: "Tranquilidad continua: mantenimiento corporativo, protección de marca y cumplimiento legal anual.",
    row4Plan: "Special Projects",
    row4BestFor: "Transacciones estratégicas",
    row4Value: "Asesoría especializada para activos complejos, inmuebles en zona restringida, propiedad ejidal o estructuras de inversión a la medida.",
    howToChoose: "Cómo elegir",
    choose1: "Si solo necesitas constituir correctamente una sociedad mexicana, elige Incorporate.",
    choose2: "Si necesitas que la sociedad quede lista para operar, facturar, firmar documentos y abrir una cuenta bancaria, elige Full Launch.",
    choose3: "Si tu empresa necesita mantenimiento legal continuo, libros corporativos, protección de marca y cumplimiento anual, elige Corporate Compliance.",
    choose4: "Si tu proyecto involucra inmuebles en zona restringida, propiedad costera, tierra ejidal o una estructura de propiedad a la medida, elige Special Projects.",
    stillUnsure: "¿Aún tienes dudas?",
    stillUnsureDesc: "Cuéntanos qué quieres establecer en México. Identificaremos la ruta adecuada, confirmaremos los pasos necesarios y te guiaremos durante el proceso."
  },
  howItWorksPage: {
    importantToKnow: "Importante",
    importantToKnowDesc: "Los tiempos dependen de la entrega oportuna de documentos, la complejidad del proyecto y los requisitos notariales o de las autoridades aplicables.",
    readyToGetStarted: "¿Listo para empezar?",
    step1: "Inicia tu solicitud de incorporación",
    step1Desc: "Comparte los datos clave de tu proyecto en México y selecciona un paquete si ya sabes cuál te queda.",
    step2: "Agenda una llamada de validación de 20 minutos",
    step2Desc: "Revisamos tu solicitud y confirmamos la ruta, el alcance y el servicio adecuado antes de cualquier pago.",
    step3: "Pago y onboarding",
    step3Desc: "Una vez alineados, enviamos el enlace de pago y comenzamos tu onboarding.",
    step4: "Nos encargamos del proceso",
    step4Desc: "Gestionamos la constitución y, si aplica, el RFC, la cuenta bancaria y el gobierno corporativo.",
    step5: "Entrega",
    step5Desc: "Recibes los documentos de tu sociedad y los entregables relacionados."
  },
  homePage: {
    step1: "Inicia tu solicitud de incorporación",
    step1Desc: "Comparte los datos clave de tu proyecto en México y selecciona un paquete si ya sabes cuál te queda.",
    step2: "Agenda una consulta",
    step2Desc: "Revisamos tu solicitud en una llamada de validación de 20 minutos y confirmamos la ruta, el alcance y el servicio adecuado antes de cualquier pago.",
    step3: "Nos encargamos de la constitución y la entrega",
    step3Desc: "Una vez alineados, gestionamos todo el proceso en línea y te entregamos los documentos de tu sociedad y los entregables relacionados."
  },
  faqPage: {
    stillHaveQuestions: "¿Tienes más dudas?",
    stillHaveQuestionsDesc: "Agenda una llamada de 20 minutos con nuestro equipo para revisar tu proyecto específico.",
    q1: "¿Qué significa llave en mano?",
    a1: "Después del onboarding inicial y la entrega de documentos, BIMCORP MX gestiona la constitución y los pasos de configuración en línea. Tú no tienes que lidiar personalmente con trámites notariales ni ante autoridades.",
    q2: "¿Necesito viajar a México?",
    a2: "Por lo general no, aunque depende de la estructura y los requisitos específicos de tu caso. La mayor parte del proceso se realiza en línea.",
    q3: "¿Tengo que pagar antes de hablar con ustedes?",
    a3: "No. El primer paso es enviar tu solicitud de incorporación, después una llamada de validación de 20 minutos, y solo tras confirmar la ruta te enviamos el enlace de pago.",
    q4: "¿Pueden apoyar con inversión extranjera?",
    a4: "Sí. La inscripción ante el Registro Nacional de Inversiones Extranjeras (RNIE) está incluida desde el plan Incorporate, y las actualizaciones continuas del RNIE se manejan dentro de Corporate Compliance.",
    q5: "¿Pueden ayudar con inmuebles en zona restringida o proyectos con terrenos?",
    a5: "Sí. Los proyectos que involucran terrenos, inmuebles o propiedades en zona restringida normalmente requieren una ruta de estructuración a la medida. Revisamos los detalles en tu llamada de validación y confirmamos la configuración adecuada.",
    q6: "¿Ofrecen servicios contables?",
    a6: "No. La contabilidad no forma parte de nuestro servicio. Nos enfocamos en constitución, estructura legal y gobierno corporativo.",
    q7: "¿Pueden encargarse del gobierno corporativo continuo?",
    a7: "Sí. Eso es parte de Corporate Compliance, que incluye libros corporativos, emisión de certificados accionarios, gestión de la asamblea anual de accionistas, registro de marca y actualizaciones del RNIE.",
    q8: "¿Cuánto tiempo toma el proceso?",
    a8: "Los tiempos dependen de la entrega oportuna de documentos, la complejidad del proyecto y los requisitos notariales o de autoridades. Te damos un cronograma específico en tu llamada de validación.",
    q9: "¿Qué documentos voy a necesitar?",
    a9: "Los requisitos exactos dependen del proyecto, pero en el onboarding te indicamos con claridad qué se necesita. Por lo general son identificaciones, comprobantes de domicilio y la información de los socios y administradores.",
    q10: "¿Necesito un director o representante establecido en México?",
    a10: "No necesitas un director residente en México para efectos de gobierno corporativo. Sin embargo, sí debes designar a un Representante Legal con RFC mexicano vigente para gestionar interacciones con el SAT y otras autoridades. BIMCORP puede actuar como tu Representante Legal en México y encargarse, en tu nombre, de las gestiones necesarias ante las autoridades locales.",
    q11: "¿Una empresa extranjera puede ser propietaria del 100% de una sociedad mexicana?",
    a11: "Sí, en la mayoría de los sectores. Los estatutos de la sociedad deben incluir una \"Cláusula Calvo\", mediante la cual los accionistas extranjeros aceptan ser considerados como nacionales respecto de su inversión y renuncian a solicitar protección diplomática en relación con dicha inversión.",
    q12: "¿Cuánto cuesta constituir una sociedad?",
    a12: "El precio varía según la estructura y el alcance de los servicios. {servicesLink}",
    a12LinkLabel: "Consulta nuestros precios",
    q13: "¿BIMCORP puede encargarse de todo el proceso en mi nombre?",
    a13: "Sí. BIMCORP gestiona de principio a fin el proceso de constitución de sociedades en México, desde el registro inicial hasta el gobierno corporativo continuo, de forma completamente online. Nuestro equipo se encarga de la documentación, las presentaciones y la coordinación con autoridades locales en tu nombre.",
    q14: "¿BIMCORP ofrece soporte de cumplimiento continuo?",
    a14: "Sí. Nuestro paquete Run the Corp cubre el gobierno corporativo continuo y mantiene a tu sociedad al día y en cumplimiento con sus obligaciones y presentaciones requeridas."
  },
  footer: {
    description: "Un servicio digital, personalizado y de punta a punta para entrar al mercado mexicano con orden legal y cumplimiento total.",
    quickLinks: "Accesos directos",
    contact: "Contacto",
    privacy: "Aviso de Privacidad",
    terms: "Términos y Condiciones",
    allRights: "Todos los derechos reservados.",
    disclaimer: "El alcance del servicio, los tiempos y los requisitos pueden variar según el proyecto, la documentación y los requisitos notariales o de autoridades aplicables."
  },
  wizard: {
    heroTitle: "Iniciar incorporación",
    heroSubtitle: "Cuéntanos tu proyecto. Diseñamos tu estructura legal y gestionamos todo el proceso en línea.",
    stepOf: "Paso {{current}} de {{total}}",
    complete: "% completado",
    back: "Atrás",
    continue: "Continuar",
    viewRecommendation: "Ver recomendación",
    common: {
      yes: "Sí",
      no: "No",
      notSure: "No estoy seguro",
      required: "Esta pregunta es obligatoria.",
      requiredText: "Completa este campo.",
      invalidEmail: "Ingresa un correo electrónico válido.",
      selectCountryCode: "Selecciona un código de país.",
      enterPhone: "Ingresa un número de teléfono.",
      uploadPartnerIDs: "Carga la identificación oficial / pasaporte de cada socio persona física.",
      uploadLegalRepID: "Carga la identificación oficial / pasaporte del representante legal.",
      countryCode: "Código de país",
      almostReady: "Tu solicitud está casi lista.",
      almostReadyDesc: "Completa la información requerida antes de enviar el formulario."
    },
    uploadCommon: {
      chooseFiles: "Selecciona archivos",
      chooseFile: "Selecciona archivo"
    },
    step0: {
      title: "Elige tu paquete",
      knowsQuestion: "¿Ya sabes qué paquete quieres?",
      selectPackage: "Selecciona tu paquete"
    },
    simplified: {
      step2: {
        title: "Detalles del proyecto",
        subtitle: "Cuéntanos sobre tu proyecto para confirmar la mejor ruta.",
        whatBuilding: "¿Qué proyecto vas a desarrollar en México?",
        whatBuildingPlaceholder: "Cuéntanos brevemente de qué se trata...",
        hasAddress: "¿Cuentas con un domicilio en México, con comprobante, que pueda usarse para la sociedad?",
        hasAddressNo: "No, lo necesito",
        rfcNeeded: "¿La sociedad necesitará apoyo para obtener su RFC?",
        bankAccountNeeded: "¿Necesitas apoyo para abrir una cuenta bancaria?",
        governanceNeeded: "¿Quieres soporte continuo de gobierno corporativo?",
        foreignParticipation: "¿El proyecto involucra participación extranjera?",
        landRestrictedZone: "¿El proyecto involucra terrenos, inmuebles o propiedad en zona restringida en México?",
        taxIDs: "RFC(s), si ya están disponibles",
        taxIDsHelp: "Indica el RFC de los socios. Uno por línea.",
        taxIDsPlaceholder: "RFCs, uno por línea..."
      }
    },
    uploadPage: {
      title: "Carga de documentos",
      subtitle: "Ningún documento es obligatorio en esta etapa, pero puedes cargarlos ahora para agilizar tu llamada de validación.",
      emailLabel: "Correo electrónico usado en tu solicitud a BIMCORP",
      emailPlaceholder: "tu@correo.com",
      emailHelp: "Usamos este correo para adjuntar tus documentos a la solicitud que ya enviaste.",
      partnerIDsLabel: "Identificación oficial / pasaporte de cada socio persona física",
      partnerIDsHelp: "Carga un archivo por socio.",
      legalRepIDLabel: "Identificación oficial / pasaporte del representante legal",
      taxIDsLabel: "RFC(s)",
      taxIDsHelp: "Indica el/los RFC de los socios y, si ya se conoce, el del representante legal propuesto. Si hay varios, uno por línea.",
      taxIDsPlaceholder: "RFCs, uno por línea...",
      optionalTitle: "Documentos opcionales, útiles para cargar ahora",
      proofOfAddressLabel: "Comprobante de domicilio (mexicano o extranjero, según aplique)",
      immigrationDocsLabel: "Documento migratorio / residencia / permiso de ingreso, si aplica",
      immigrationDocsHelp: "Carga tarjeta de residencia, permiso migratorio, documento de ingreso o cualquier documento migratorio equivalente.",
      csfLabel: "Para el representante legal, si es mexicano: Constancia de Situación Fiscal",
      marriageCertLabel: "Si está casado: acta de matrimonio",
      submitBtn: "Cargar documentos",
      submitting: "Cargando…",
      successTitle: "Documentos cargados",
      successMessage: "Tus documentos se agregaron a tu expediente en BIMCORP. Nuestro equipo los revisará antes de tu llamada.",
      errorNotFound: "No encontramos una solicitud de BIMCORP asociada a este correo. Por favor contacta a BIMCORP antes de cargar documentos.",
      errorNoFiles: "Por favor adjunta al menos un documento.",
      errorGeneric: "No pudimos cargar tus documentos. Intenta de nuevo o contacta a BIMCORP.",
      uploadAnother: "Cargar más documentos"
    },
    packageNames: {
      incorporate: "Incorporate",
      fullLaunch: "Full Launch",
      corporateCompliance: "Corporate Compliance",
      specialProject: "Special Project Structuring"
    },
    packageDescs: {
      incorporate: "Servicio único de constitución para clientes listos para formalizar su sociedad en México.",
      fullLaunch: "Constitución más preparación operativa: RFC, e.firma y apertura de cuenta bancaria corporativa.",
      corporateCompliance: "Full Launch más cumplimiento corporativo gestionado de forma continua.",
      specialProject: "Estructuración a la medida para inmuebles en zona restringida, propiedad compleja o proyectos especiales."
    },
    step1: {
      title: "Detalles del proyecto",
      whatBuilding: "¿Qué proyecto vas a desarrollar en México?",
      whatBuildingPlaceholder: "Cuéntanos brevemente de qué se trata...",
      companyActivity: "¿Cuál va a ser la actividad principal de tu empresa?",
      companyActivityPlaceholder: "Selecciona una actividad...",
      activity: {
        technology: "Tecnología / Software",
        realEstate: "Bienes raíces",
        consulting: "Consultoría / Servicios",
        manufacturing: "Manufactura",
        retail: "Retail / E-commerce",
        hospitality: "Hospitalidad / Turismo",
        investment: "Inversión / Holding",
        other: "Otra"
      },
      activityOther: "Especifica la actividad",
      activityOtherPlaceholder: "Ej.: Salud, educación, agricultura...",
      businessType: "¿Es una sociedad nueva o la expansión de un negocio existente?",
      businessTypeNew: "Sociedad nueva",
      businessTypeExpansion: "Expansión hacia México",
      businessTypeSpv: "Vehículo de propósito específico",
      hasNames: "¿Ya tienes nombres propuestos para la sociedad?",
      nameOption1: "Opción 1",
      nameOption2: "Opción 2 (opcional)",
      nameOption3: "Opción 3 (opcional)"
    },
    step2: {
      title: "Estructura accionaria",
      whoOwns: "¿Quiénes serán los socios de la sociedad?",
      individuals: "Número de socios personas físicas",
      entities: "Número de socios personas morales",
      ownershipAgreed: "¿Ya se acordaron los porcentajes de participación?",
      ownershipNeedHelp: "No, necesitamos apoyo",
      legalRep: "¿Quién será el representante legal de la sociedad en México?",
      legalRepPartner: "Uno de los socios",
      legalRepThirdParty: "Un tercero",
      legalRepNotDecided: "Aún no se decide",
      legalRepName: "Nombre del representante legal propuesto",
      legalRepNamePlaceholder: "Nombre completo"
    },
    step3: {
      title: "Necesidades operativas",
      hasAddress: "¿Cuentan con un domicilio en México (con comprobante de domicilio) que pueda usarse para la sociedad?",
      hasAddressNeedOne: "No, necesitamos uno",
      rfc: "¿La sociedad necesitará apoyo para obtener su RFC?",
      bank: "¿Necesitarán apoyo para abrir una cuenta bancaria?",
      governance: "¿Necesitan el servicio de gobierno corporativo?"
    },
    step4: {
      title: "Estructuración especial y documentos",
      foreign: "¿El proyecto involucrará participación extranjera?",
      land: "¿El proyecto involucrará terrenos, inmuebles o propiedad en zona restringida en México?",
      uploadTitle: "Carga de documentos",
      uploadIntro: "Puedes subir tus documentos ahora para agilizar el proceso. Si no los tienes listos, puedes continuar y BIMCORP te los pedirá más adelante.",
      partnerIDsLabel: "Identificación oficial / pasaporte de cada socio persona física",
      partnerIDsHelp: "Carga un archivo por socio.",
      chooseFiles: "Selecciona archivos",
      chooseFile: "Selecciona archivo",
      upload: "Cargar",
      legalRepIDLabel: "Identificación oficial / pasaporte del representante legal",
      required: "Obligatorio",
      taxIDsLabel: "RFC / identificación fiscal",
      taxIDsHelp: "Indica los RFC o identificaciones fiscales de los socios y, si ya se conoce, del representante legal propuesto. Si son varios, agrega uno por línea.",
      taxIDsPlaceholder: "RFC / identificaciones fiscales (uno por línea)...",
      optionalTitle: "Documentos opcionales (te recomendamos cargarlos desde ahora)",
      proofAddress: "Comprobante de domicilio (mexicano o extranjero, según aplique)",
      immigration: "Documento migratorio, residencia o permiso de internación, si aplica",
      immigrationHelp: "Carga la tarjeta de residencia, permiso migratorio, documento de internación o cualquier documento equivalente",
      csf: "Para el representante legal, si es mexicano: Constancia de Situación Fiscal",
      marriage: "Si está casado(a): acta de matrimonio"
    },
    step5: {
      title: "Contacto y agenda",
      intro: "Completa tus datos para recibir tu ruta recomendada y agendar tu llamada de validación.",
      fullName: "Nombre completo *",
      fullNamePlaceholder: "Tu nombre completo",
      email: "Correo electrónico *",
      emailPlaceholder: "tu.correo@ejemplo.com",
      phone: "Teléfono / WhatsApp *",
      phonePlaceholder: "+52 5545629769",
      country: "País *",
      countryPlaceholder: "Tu país",
      preferredLang: "Idioma preferido",
      langEnglish: "Inglés",
      langSpanish: "Español",
      langOther: "Otro"
    },
    recommendation: {
      title: "Ruta recomendada",
      pricingTitle: "Precio",
      ready: "¿Listo para avanzar?",
      readyDesc: "Agenda abajo tu llamada de validación de 20 minutos. No se requiere ningún pago antes de la llamada.",
      bookCall: "Agenda tu llamada de validación de 20 minutos",
      backToWizard: "Volver a la solicitud",
      installmentsAvailable: "(Pagos en parcialidades disponibles)",
      oneTimeFee: "pago único",
      initialSetupFee: "cuota inicial",
      monthSuffix: "/mes",
      commitment: "compromiso mínimo de 12 meses",
      startCorpTitle: "Incorporate",
      startCorpDesc: "Servicio de constitución para empresas listas para formalizar su sociedad en México.",
      launchCorpTitle: "Full Launch",
      launchCorpDesc: "Configuración integral para empresas que requieren constitución, RFC, e.firma y apertura de cuenta bancaria corporativa.",
      runCorpTitle: "Corporate Compliance",
      runCorpDesc: "Full Launch más cumplimiento gestionado para empresas que requieren acompañamiento continuo después de la constitución.",
      customProjectTitle: "Proyecto a la medida",
      customProjectDesc: "Tu proyecto requiere una ruta legal y de propiedad personalizada. Revisaremos los detalles en tu llamada de validación y confirmaremos el alcance y la cotización antes de cualquier pago.",
      customPricingNote: "Esta ruta requiere una cotización personalizada. Revisamos los detalles y confirmamos el alcance y el precio en tu llamada de validación de 20 minutos. No se requiere ningún pago antes de la llamada.",
      scheduleTitle: "Agenda tu llamada de validación",
      scheduleDesc: "Hemos recibido tu solicitud de constitución. Por favor agenda tu llamada de validación para que nuestro equipo revise tu solicitud y confirme los siguientes pasos.",
      loadingScheduler: "Cargando agenda…",
      allSetTitle: "Todo listo.",
      allSetBody: "Recibimos tu información y tu llamada de validación agendada. Nuestro equipo revisará tu solicitud antes de la reunión.",
      requestSubmittedTitle: "Tu solicitud fue enviada.",
      packageSummaryPrefix: "Según tu selección, el paquete para ti es",
      packageSummarySuffix: "BIMCORP confirmará el alcance final durante tu llamada de validación.",
      packageSummaryCustom: "Según tu selección, tu ruta se confirmará durante la llamada de validación. BIMCORP te compartirá el alcance y el precio antes de cualquier pago.",
      returnHome: "Volver al inicio",
      callScheduledLabel: "Llamada de validación agendada",
      scheduleReminder: "Tu solicitud ya fue enviada. Por favor agenda tu llamada de validación para completar el proceso.",
      restart: "Iniciar nueva solicitud",
      selectedNote: "Con base en tu selección, este es el paquete que elegiste. BIMCORP confirmará el alcance final durante tu llamada de validación.",
      conflictNote: "Algunas de tus respuestas pueden requerir revisión adicional. BIMCORP confirmará durante tu llamada de validación si este paquete es el adecuado."
    },
    overlay: {
      titleUpload: "Por favor espera mientras subimos tus documentos.",
      titleSubmit: "Por favor espera mientras enviamos tu solicitud.",
      subtitle: "No cierres esta ventana."
    },
    readonly: {
      banner: "Tu solicitud ya fue enviada. No te preocupes, si necesitas hacer algún cambio o aclaración, por favor háznoslo saber durante tu llamada de validación.",
      viewRecommendation: "Ver mi recomendación"
    }
  },
  insights: {
    eyebrow: "Insights",
    title: "Publicaciones sobre la constitución de empresas en México",
    subtitle: "Textos prácticos sobre constitución de sociedades, inversión extranjera, cumplimiento corporativo y estructuras legales para hacer negocios en México.",
    readMore: "Leer más",
    by: "Por",
    backToInsights: "Volver a Insights",
    empty: "Aún no hay artículos. Pronto publicaremos.",
    metaTitle: "Insights",
    metaDescription: "BIMCORP MX Insights: textos prácticos sobre constitución de empresas en México, inversión extranjera, cumplimiento corporativo y estructuras legales."
  }
};

export default es;
